import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ConfigService} from "../app.constant";
import {AuthService} from "./auth.service";

@Injectable({
    providedIn: 'root'
})
export class LoginService {

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private configService: ConfigService
    ) { }

    public login(user: any) {
        let headers = new HttpHeaders({'Content-Type': 'application/json'});
        return this.http.post(this.configService.authApi + '/login', user,  {headers: headers});
    }

    public refreshToken() {
        return this.http.post(this.configService.authApi + '/refresh-token', {refresh_token: this.authService.getRefreshToken()}).toPromise()
    }

    public logout() {
        return this.http.post(this.configService.authApi + '/logout', {session: this.authService.getSession()}).toPromise()
    }
}
